/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, OnInit } from '@angular/core';
import { Logger } from '@app/core';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { DataStateChangeEvent, GridDataResult } from '@progress/kendo-angular-grid';
import { ApiQuery } from '@app/core/http/api-query';
import { CountriesService } from '@app/settings/countries/countries.service';
import { CountriesFormService } from '@app/settings/countries/countries-form.service';
import { Country } from '@app/settings/countries/countries.model';
import { LaravelModelsEnum } from '@app/shared/models/model.model';
import { KendoGridComponent } from '@app/shared/kendo/kendo-grid.component';
import { KendoGridService } from '@app/shared/kendo/kendo-grid.service';
import { environment } from '@env/environment';
import { CustomKendoFilter } from '@app/shared/kendo/custom-kendo-filter';
import { UserRoleType } from '@app/settings/users/user-role-type.enum';
import { AccessService } from '@app/core/access/access.service';
import { CountriesSeoFormService } from '@app/settings/countries/countries-seo-form.service';
import { MediaLibraryAcceptTypes } from '@app/shared/components/media-library/media-library-accept-types.enum';

const log = new Logger('countriesListComponent');

@Component({
  selector: 'app-countries-list',
  templateUrl: './countries-list.component.html',
  styleUrls: ['./countries-list.component.scss'],
})
export class CountriesListComponent extends KendoGridComponent implements OnInit {
  countriesResponse: PaginatedResponse;
  data: GridDataResult;
  state: DataStateChangeEvent;
  apiQuery: ApiQuery = new ApiQuery();
  laravelModels = LaravelModelsEnum;
  env = environment;
  UserRoleType = UserRoleType;
  MediaLibraryAcceptTypes = MediaLibraryAcceptTypes;

  constructor(
    private countryService: CountriesService,
    private countriesFormService: CountriesFormService,
    protected kendoGridService: KendoGridService,
    public accessService: AccessService,
    private countriesSeoFormService: CountriesSeoFormService
  ) {
    super(kendoGridService);
  }

  ngOnInit() {
    this.state = CustomKendoFilter.getStateFromStorage('CountriesListComponent');
    this.loadData(this.state);
  }

  /**
   * Load data from API
   */
  loadData(state: DataStateChangeEvent = null) {
    this.state = state;
    this.apiQuery.setDataSetFilters(state);

    this.countryService.index(this.apiQuery).subscribe((response: PaginatedResponse) => {
      this.countriesResponse = response;
      this.data = response.getGridData();
    });
    CustomKendoFilter.pushStateInStorage('CountriesListComponent', this.state);
  }

  add() {
    this.countriesFormService.open().then(
      (response) => {
        this.loadData();
      },
      (err) => {
        log.info('modal closed');
      }
    );
  }

  /**
   *
   * @param country Country object
   */
  edit(country: Country) {
    this.countriesFormService.open(country).then(
      (response) => {
        this.loadData();
      },
      (err) => {
        log.info('modal closed');
      }
    );
  }

  /**
   *
   * @param country Country object
   */
  delete(country: Country) {
    this.countryService.destroy(country.id).subscribe(() => {
      this.loadData(this.state);
    });
  }

  clearFilters() {
    this.apiQuery = new ApiQuery();
    this.loadData();
  }

  editSeo(country: Country): void {
    this.countriesSeoFormService.open(country);
  }
}
